import {
  type ModificationGroupLimits,
  type ProductModifierGroups,
} from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Extracts modification limits from a list of product modifier groups.
 *
 * Modification limits are used to determine the number of allowed modifications
 * and to calculate their cost.
 */
export function extractModificationsLimits(groups: ProductModifierGroups) {
  return groups.reduce<ModificationGroupLimits>((limits, group) => {
    const {
      name,
      displayName,
      allowMultipleQuantity,
      minAggregateQuantity,
      maxAggregateQuantity,
      freeAggregateQuantity,
    } = group;

    return {
      ...limits,
      [name]: {
        displayName,
        allowMultipleQuantity,
        minAggregateQuantity,
        maxAggregateQuantity,
        freeAggregateQuantity,
      },
    };
  }, {});
}
